import { render, staticRenderFns } from "./main-card-icon.vue?vue&type=template&id=8cd91f3a&scoped=true&"
import script from "./main-card-icon.vue?vue&type=script&lang=js&"
export * from "./main-card-icon.vue?vue&type=script&lang=js&"
import style0 from "./main-card-icon.vue?vue&type=style&index=0&id=8cd91f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd91f3a",
  null
  
)

export default component.exports